import { useMemo } from "react";
import { Box, Lottie, animations, resolveThemeToken } from "@repo/ui";
import { useTheme } from "@repo/tokens";
import { getThemedBlueLoader } from "./blueLoaderTheme";

export const PageLoader = () => {
  const { theme, themeName, subjectKey } = useTheme();
  const primaryCss =
    resolveThemeToken(theme, "action.primary.default") ?? "#027BFF";
  const themedLoader = useMemo(
    () => getThemedBlueLoader(animations.blueLoader, primaryCss),
    [primaryCss, themeName, subjectKey],
  );

  return (
    <Box
      style={{
        flex: 1,
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.surface.page,
      }}
    >
      <div style={{ width: 200, height: 200 }}>
        <Lottie
          key={`${themeName}:${subjectKey ?? ""}:${primaryCss}`}
          animation={themedLoader}
        />
      </div>
    </Box>
  );
};
